var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-dialog', _vm._g(_vm._b({
    staticClass: "qn-cropper",
    attrs: {
      "modal": false,
      "title": "裁剪"
    }
  }, 'el-dialog', _vm.$attrs, false), _vm.$listeners), [_c('vue-cropper', _vm._b({
    ref: "qnCropper",
    style: ({
      width: _vm.width,
      height: _vm.height
    }),
    attrs: {
      "mode": "cover",
      "img": _vm.data.url,
      "output-size": _vm.outputSize,
      "info-true": _vm.infoTrue,
      "can-scale": _vm.canScale,
      "auto-crop": _vm.autoCrop,
      "auto-crop-width": _vm.autoCropWidth,
      "auto-crop-height": _vm.autoCropHeight,
      "fixed": _vm.fixed,
      "fixed-number": _vm.fixedNumber,
      "fixed-box": _vm.fixedBox,
      "can-move-box": _vm.canMoveBox,
      "centerBox": _vm.centerBox,
      "output-type": _vm.outputType,
      "enlarge": _vm.enlarge
    }
  }, 'vue-cropper', _vm.$attrs, false)), _vm._v(" "), (_vm.funBar) ? _c('el-button-group', [_c('el-button', {
    attrs: {
      "title": "旋转"
    },
    on: {
      "click": _vm.handleRotateLeft
    }
  }, [_vm._v("\n\t\t\t\t旋转\n\t\t\t")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "title": "放大"
    },
    on: {
      "click": _vm.handleScalePlus
    }
  }, [_vm._v("\n\t\t\t\t放大\n\t\t\t")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "title": "缩小"
    },
    on: {
      "click": _vm.handleScaleSubtract
    }
  }, [_vm._v("\n\t\t\t\t缩小\n\t\t\t")])], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.handleToConfirm
    }
  }, [_vm._v("确 定")]), _vm._v(" "), _c('el-button', {
    on: {
      "click": _vm.close
    }
  }, [_vm._v("取 消")])], 1)], 1)
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-0d850c2c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0d850c2c","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/QnUpload-1.0.0/cropper/index.vue
// module id = 1KL9
// module chunks = 212